import { errorResponseHelper } from '@/helpers'
import { sessionPersistenceFailure } from '@/helpers/session-failure'
import { underLoadingFunction } from '../helpers/under-loading'
import LivenessHiveService from '@/services/liveness.hive.service'

import {
  setToken,
  setDataUser
} from '@/auth'

const state = {
}

const mutations = {
}

const getters = {
}

const actions = {
  validInitTransaction: underLoadingFunction(async({ commit }, payload) => {
    try {
      const { data } = await LivenessHiveService.validInitTransaction(payload)
      return { success: true, data }
    } catch (error) {
      errorResponseHelper.display(error)
      return { success: false, error }
    }
  }),
  startFlowTransaction: underLoadingFunction(async({ commit }, payload) => {
    try {
      const { data } = await LivenessHiveService.startFlowTransaction(payload)
      const session = data.data || {}
      if (!session.token || !await setToken(session.token)) {
        const error = sessionPersistenceFailure('start_flow', session.token ? 'token_write_failed' : 'token_missing')
        errorResponseHelper.display(error)
        return { success: false, error }
      }

      if (session.newCode && !await setDataUser(session.newCode)) {
        const error = sessionPersistenceFailure('start_flow', 'user_code_write_failed')
        errorResponseHelper.display(error)
        return { success: false, error }
      }

      return { success: true, data }
    } catch (error) {
      errorResponseHelper.display(error)
      return { success: false, error }
    }
  }),
  validIDDocumentsTransaction: underLoadingFunction(async({ commit }, payload) => {
    try {
      const { data } = await LivenessHiveService.validIDDocumentsTransaction(payload)
      return { success: true, data }
    } catch (error) {
      errorResponseHelper.display(error)
      return { success: false, error }
    }
  }),
  resumeTransaction: underLoadingFunction(async({ commit }, payload) => {
    try {
      const { data } = await LivenessHiveService.resumeTransaction(payload)

      if (data.data && data.data.token) {
        if (!await setToken(data.data.token)) {
          const error = sessionPersistenceFailure('resume', 'token_write_failed')
          errorResponseHelper.display(error)
          return { success: false, error }
        }
      }

      return { success: true, data }
    } catch (error) {
      errorResponseHelper.display(error)
      return { success: false, error }
    }
  }),
  addressTransaction: underLoadingFunction(async({ commit }, payload) => {
    try {
      const { data } = await LivenessHiveService.addressTransaction(payload)

      if (data.data && data.data.token) {
        if (!await setToken(data.data.token)) {
          const error = sessionPersistenceFailure('address', 'token_write_failed')
          errorResponseHelper.display(error)
          return { success: false, error }
        }
      }

      return { success: true, data }
    } catch (error) {
      errorResponseHelper.display(error)
      return { success: false, error }
    }
  }),
  validOthersDocumentsTransaction: underLoadingFunction(async({ commit }, payload) => {
    try {
      const { data } = await LivenessHiveService.validOthersDocumentsTransaction(payload)

      if (data.data && data.data.token) {
        if (!await setToken(data.data.token)) {
          const error = sessionPersistenceFailure('other_documents', 'token_write_failed')
          errorResponseHelper.display(error)
          return { success: false, error }
        }
      }

      return { success: true, data }
    } catch (error) {
      errorResponseHelper.display(error)
      return { success: false, error }
    }
  })
}

export default {
  state,
  mutations,
  actions,
  getters
}
